import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNotifications } from "../../context/NotificationContext";
import "./MobileMenu.css";
import HomeIcon from "../../assets/icons/home-house-big.svg";
import UsersIcon from "../../assets/icons/users.svg";
import TemplatesIcon from "../../assets/icons/templates.svg";
import ExerciseIcon from "../../assets/icons/exercise.svg";
import CameraIcon from "../../assets/icons/camera.svg";
import QuestionIcon from "../../assets/icons/question.svg";
import ChartIcon from "../../assets/icons/chart.svg";
import SettingsIcon from "../../assets/icons/settings.svg";
import NotificationsIcon from "../../assets/icons/notifications.svg";
import LogoutIcon from "../../assets/icons/logout.svg";

export default function MobileMenu({ isOpen, onClose, logout }) {
  const { t } = useTranslation();
  const { unreadCount } = useNotifications();

  if (!isOpen) {
    return null;
  }

  const handleLinkClick = () => {
    onClose();
  };

  const handleLogout = () => {
    onClose();
    logout();
  };

  return (
    <>
      <div className="mobile-menu-overlay" onClick={onClose} />
      <div className="mobile-menu">
        <div className="mobile-menu-header">
          <button className="mobile-menu-close" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <div className="mobile-menu-content">
          <div className="mobile-menu-main">
            <NavLink 
              to="/dashboard" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <img src={HomeIcon} alt="dashboard" className="svg-icon grey" />
              <span>{t("menu.dashboard")}</span>
            </NavLink>
            
            <NavLink 
              to="/patients" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <img src={UsersIcon} alt="patients" className="svg-icon grey" />
              <span>{t("menu.patients")}</span>
            </NavLink>
            
            <NavLink 
              to="/programs" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <img src={TemplatesIcon} alt="programs" className="svg-icon grey" />
              <span>{t("menu.programs")}</span>
            </NavLink>
            
            <NavLink 
              to="/exercises" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <img src={ExerciseIcon} alt="exercises" className="svg-icon grey" />
              <span>{t("menu.exercises")}</span>
            </NavLink>

            <NavLink 
              to="/materials" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <img src={CameraIcon} alt="materials" className="svg-icon grey" />
              <span>{t("menu.materials")}</span>
            </NavLink>
            
            <NavLink 
              to="/questionnaires" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <img src={QuestionIcon} alt="questionnaires" className="svg-icon grey" />
              <span>{t("menu.questionnaires")}</span>
            </NavLink>
            
            <NavLink 
              to="/analysis" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <img src={ChartIcon} alt="analysis" className="svg-icon grey" />
              <span>{t("menu.analysis")}</span>
            </NavLink>
            
            <NavLink 
              to="/preferences" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <img src={SettingsIcon} alt="settings" className="svg-icon grey" />
              <span>{t("menu.settings")}</span>
            </NavLink>
          </div>
          
          <div className="mobile-menu-bottom">
            <a
              href="https://hoferdigital.atlassian.net/wiki/spaces/SS/pages/2949775361/therapeut.sophyapp.com+-+Wiki+f+r+Therapeuten"
              className="mobile-menu-item"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleLinkClick}
            >
              <img src={QuestionIcon} alt="help" className="svg-icon grey" />
              <span>{t("menu.help")}</span>
            </a>

            <NavLink 
              to="/notifications" 
              className="mobile-menu-item" 
              onClick={handleLinkClick}
            >
              <div className="notification-icon-wrapper">
                <img src={NotificationsIcon} alt="notifications" className="svg-icon grey" />
                {unreadCount > 0 && (
                  <span className="notification-badge">{unreadCount}</span>
                )}
              </div>
              <span>{t("menu.notifications")}</span>
            </NavLink>
            
            <button 
              className="mobile-menu-item mobile-menu-logout" 
              onClick={handleLogout}
            >
              <img src={LogoutIcon} alt="logout" className="svg-icon grey" />
              <span>{t("menu.logout")}</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
